import $ from 'jquery';
import { initSDEKMap } from '../../scripts/sdekMaps';
import '../../plugins/jquery.suggestions@21.12.0.min.js';

const semantics = {
    'sdekModalButtonClassName': 'js-open-sdek-modal',
    'addressInputSelector': '#cartv1form-address',
};

$(function() {

    var cartPageV1 = new CartPageV1();
    cartPageV1.subscribe();
    
});

/**
 * Общая JS-функциональность страницы корзины, которая находится
 * вне React-приложения
 */
class CartPageV1
{
    constructor() {
    }
    
    subscribe() {

        const self = this;

        $('body').on(
            'click', 
            `.${semantics.sdekModalButtonClassName}`, 
            function(e) {
                const $map = $('#deliverySDEK');
                if (!$map.hasClass('_init')) {
                    initSDEKMap();
                }
            }
        );

        $('body').on(
            'focus', 
            semantics.addressInputSelector, 
            function(e) {
                $("#cartv1form-address").suggestions({
                    token: "18ed7d4dc55e46fc57812bbb77ac802533be8475",
                    type: "ADDRESS",
                    minChars: 3
                });
            }
        );
    }    
}